'use client';

import { ElementType, FC } from 'react';

import { DynamicPageContentType } from '@ravago/shared/page-data/models/contentful';
import { NormalizedNavigationItem } from '@ravago/shared/page-data/models/contentful-mapped';
import { NavItem } from '@ravago/shared/radiance/components/navigation/components/NavItem/NavItem';

import { usePathname } from 'next/navigation';

import { AppUtils } from '../../../utils/app/app.utils';
import { DataTestSelector } from '../../../utils/format/format.utils';
import { NavigationUtils } from '../../../utils/navigation/navigation.utils';

interface Props {
   locale: string;
   navigationItems: NormalizedNavigationItem[];
   hideLabel?: boolean;
   linkComponent?: ElementType;
   variant?: 'normal' | 'alt';
   cyLabel?: string;
   dynamicPageUrls?: { [key in DynamicPageContentType]?: string };
   onClick?: () => void;
}

export const MenuItem: FC<Props> = ({ locale, navigationItems, hideLabel, linkComponent, variant = 'normal', cyLabel, dynamicPageUrls, onClick }) => {
   const path = usePathname();

   const isActive = (item: NormalizedNavigationItem) => {
      if (variant === 'normal' || !path) return false;

      const { page } = item;

      return page?.route === path.replace(`/${locale}/`, '');
   };

   return navigationItems.map((item, index) => (
      <NavItem
         key={AppUtils.getKey('menu-item', index)}
         attributes={{ ...(cyLabel && { ...DataTestSelector(cyLabel, item.label) }) }}
         href={NavigationUtils.buildRoute(locale, item, dynamicPageUrls)}
         size="md"
         color={variant === 'normal' ? 3 : undefined}
         target={item.openInNewTab ? '_blank' : undefined}
         onClick={onClick}
         icon={item.icon ?? undefined}
         trailingIcon={!hideLabel && item.openInNewTab ? 'external-link' : undefined}
         linkComponent={linkComponent}
         active={isActive(item)}
      >
         {!hideLabel && item.label}
      </NavItem>
   ));
};
